import React from 'react'
import { BlockWorkerProvider } from './context/BlockWorkerProvider'
import { BlockWorkerMain } from './components/BlockWorkerMain'

export const BlockWorkerPage = () => {
  return (
    <BlockWorkerProvider>
      <BlockWorkerMain />
    </BlockWorkerProvider>
  )
}
